<dialog shEscapeDialog #dynamicDialog (shEscapePressed)="closeDialog()" class="sh-dialog-container">
    <div [ngClass]="dialogStyle$ | async">
        <header *ngIf="dialogConfig.title" class="sh-dialog__header">
            <h3 class="sh-dialog__header__title">{{ dialogConfig.title }}</h3>
        </header>
        <ng-template shDialogInsertion></ng-template>
        <button class="sh-pure-icon-button sh-dialog__close" aria-label="close" (click)="closeDialog()">
            <svg sh-icon [name]="'close'" class="sh-icon-button__icon" aria-hidden="true"></svg>
        </button>
    </div>
</dialog>
